import { STARAPIErrorResponse } from "../types/types"
import { getSelectedServer } from "./apiServerStore"
import { getAccessToken } from "./authHelpers"



const apiRouteV1                = '/api/v1'
const apiRouteV2                = '/api/v2'
const apiRouteV3                = '/api/v3'
export const loginRoute         = `${apiRouteV1}/auth/login`
export const userRoute          = `${apiRouteV1}/user`
export const workflowsRoute     = `${apiRouteV2}/workflows`
export const groupsRoute        = `${apiRouteV1}/group`
export const workflowGroupRoute = `${apiRouteV1}/workflow_group`
export const sectionScanRoute   = `${apiRouteV2}/section-scans`
export const isolatedScanRoute  = `${apiRouteV3}/isolated-scans`
export const isolatedScanIMURoute  = `${apiRouteV2}/isolated_scan_imu`
export const isolatedScanMotionRoute = `${apiRouteV2}/isolated_scan_motion`
export const isolatedScanThermalRoute = `${apiRouteV2}/isolated_scan_thermal`
export const analysisRoute      = `${apiRouteV1}/scan_analysis`
export const freehandsScanRoute = `${apiRouteV1}/freehand_scan`
export const scanMediaRoute     = `${apiRouteV2}/scan_media`
export const analysisRouteV2 = `${apiRouteV2}/star-processing`
export const scopeWorkflowRoute = `${apiRouteV1}/scope_workflow`
export const claddingMaterialRoute = `${apiRouteV1}/cladding_material`
export const insulationMaterialRoute = `${apiRouteV1}/insulation_material`
export const locationRoute = `${apiRouteV1}/workflow_location`
export const workflowAnalysisRoute = `${apiRouteV1}/analysis`
export const isolatedScanSystemDataRoute = `${apiRouteV2}/isolated_scan_system_data`
export const processedSectionsRoute = `${apiRouteV3}/processed-sections`
export const isolatedScanCommentRoute = `${apiRouteV2}/isolated-scan-comments`

/**
 * Gets the response to a http fetch request.
 * 
 * @param url to make the request to
 * @param method http method to include in the request
 * @param body to include in the request
 * @param headers request headers. Default headers are json format with authorization token
 * 
 * @returns json response or error
 */
type GenericRequestOptions = {
  url: string;
  method: "POST" | "PUT" | "GET" | "DELETE";
  body?: string | null;
  headers?: HeadersInit | null;
  query?: Record<string, string | number | number[] | boolean | undefined>;
  raw?: boolean;
};

export class STARAPIError extends Error {
  public readonly statusCode: number;
  public readonly body: STARAPIErrorResponse;

  constructor(statusCode: number, body: STARAPIErrorResponse) {
    super(body.message);
    this.statusCode = statusCode;
    this.body = body;
    this.name = "APIError";
    Object.setPrototypeOf(this, STARAPIError.prototype);
  }
}

export const genericRequest = async ({
  url,
  method,
  body = null,
  headers = null,
  query,
  raw = false
}: GenericRequestOptions) => {
  try {
    const token = await getAccessToken();

    headers ??= {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    };

    const baseUrl = getSelectedServer();
    const fullUrl = new URL(`${baseUrl}${url}`);

    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value instanceof Array) {
          value.forEach((item: number) => {
            fullUrl.searchParams.append(key, String(item))
          })
            
        } else if (value !== undefined) {
          fullUrl.searchParams.set(key, String(value))
        }
      })
    }

    const response = await fetch(fullUrl.toString(), {
      method,
      body,
      headers,
      redirect: "error"
    });

    if (response.ok) {
      return raw ? response : await response.json();
    }

    if (response.status === 401)
      return new STARAPIError(401, { message: "Unauthorized", statusCode: 401 });

    if (response.status === 404) {
      return new STARAPIError(404, { message: "Resource not found", statusCode: 404 });
    }

    const errorData = await response.json().catch(() => {
      throw new STARAPIError(response.status, { message: "Request failed", statusCode: response.status });
    });

    return new STARAPIError(response.status, { message: errorData.detail, statusCode: response.status });

  } catch (error) {
    return new STARAPIError(500, { message: error instanceof Error ? error.message : "An unknown error occurred", statusCode: 500 });
  }
};
